import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronDown, faTimes, faPlusSquare, faTrash, faCogs, faPencilAlt, faSignOutAlt, faHome, faStopCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faChevronDown)
library.add(faTimes)
library.add(faPlusSquare)
library.add(faTrash)
library.add(faCogs)
library.add(faSignOutAlt)
library.add(faHome)
library.add(faPencilAlt)
library.add(faStopCircle)


Vue.component('font-awesome-icon', FontAwesomeIcon)
